import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  // undefined = jeszcze sprawdzamy, null = niezalogowany, obiekt = zalogowany
  const [player, setPlayer] = useState(undefined);
  const [loginOpen, setLoginOpen] = useState(false);

  const refresh = useCallback(
    () => api.get("/player/me").then((r) => setPlayer(r.data)).catch(() => setPlayer(null)),
    [],
  );
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (loginName, password) => {
    await api.post("/player/login", { login: loginName, password });
    await refresh();
  };
  const logout = async () => {
    try { await api.post("/player/logout"); } finally { setPlayer(null); }
  };

  return (
    <PlayerContext.Provider value={{ player, login, logout, refresh, loginOpen, openLogin: () => setLoginOpen(true), closeLogin: () => setLoginOpen(false) }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
